import { render, staticRenderFns } from "./checkEditorBreath.vue?vue&type=template&id=2cd49c5d&scoped=true&"
import script from "./checkEditorBreath.vue?vue&type=script&lang=js&"
export * from "./checkEditorBreath.vue?vue&type=script&lang=js&"
import style0 from "./checkEditorBreath.vue?vue&type=style&index=0&id=2cd49c5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd49c5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cd49c5d')) {
      api.createRecord('2cd49c5d', component.options)
    } else {
      api.reload('2cd49c5d', component.options)
    }
    module.hot.accept("./checkEditorBreath.vue?vue&type=template&id=2cd49c5d&scoped=true&", function () {
      api.rerender('2cd49c5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/check/components/checkEditorBreath.vue"
export default component.exports